import {
  Dashboard, Campaign, School, Group, AssignmentTurnedIn, EventNote, AccountBalance,
  Schedule, Description, Assignment, Notifications, History, Person,
  PublishedWithChanges,
} from '@mui/icons-material';
import type { Role } from '../shared/types';
import { ReactNode } from 'react';

export interface NavItem {
  to: string;
  label: string;
  icon: ReactNode;
  roles: Role[];
}

export const NAV_ITEMS: NavItem[] = [
  { to: '/portal', label: 'Dashboard', icon: <Dashboard />, roles: ['STUDENT', 'TEACHER', 'ADMIN', 'PRINCIPAL'] },
  { to: '/portal/notices', label: 'Notice Board', icon: <Campaign />, roles: ['STUDENT', 'TEACHER', 'ADMIN', 'PRINCIPAL'] },
  { to: '/portal/students', label: 'Students', icon: <School />, roles: ['ADMIN', 'PRINCIPAL'] },
  { to: '/portal/teachers', label: 'Teachers', icon: <Group />, roles: ['ADMIN', 'PRINCIPAL'] },
  { to: '/portal/marks', label: 'Marks Entry', icon: <AssignmentTurnedIn />, roles: ['TEACHER'] },
  { to: '/portal/marks', label: 'My Results', icon: <AssignmentTurnedIn />, roles: ['STUDENT'] },
  { to: '/portal/results', label: 'Result Workflow', icon: <PublishedWithChanges />, roles: ['PRINCIPAL'] },
  { to: '/portal/marksheets', label: 'Marksheets', icon: <Description />, roles: ['STUDENT'] },
  { to: '/portal/attendance', label: 'Attendance', icon: <EventNote />, roles: ['STUDENT', 'TEACHER', 'PRINCIPAL'] },
  { to: '/portal/fees', label: 'Fees', icon: <AccountBalance />, roles: ['STUDENT', 'ADMIN', 'PRINCIPAL'] },
  { to: '/portal/timetable', label: 'Timetable', icon: <Schedule />, roles: ['STUDENT', 'TEACHER', 'ADMIN', 'PRINCIPAL'] },
  { to: '/portal/assessments', label: 'Assessments', icon: <Assignment />, roles: ['STUDENT', 'TEACHER'] },
  { to: '/portal/notifications', label: 'Notifications', icon: <Notifications />, roles: ['STUDENT', 'TEACHER', 'ADMIN', 'PRINCIPAL'] },
  { to: '/portal/audit-log', label: 'Audit Log', icon: <History />, roles: ['ADMIN', 'PRINCIPAL'] },
  { to: '/portal/profile', label: 'Profile', icon: <Person />, roles: ['STUDENT', 'TEACHER', 'ADMIN', 'PRINCIPAL'] },
];

export function navItemsForRole(role: Role): NavItem[] {
  return NAV_ITEMS.filter((it) => it.roles.includes(role));
}
